import { getCookie } from '@/assets/utils/cookie'
import cookie from 'vue-cookies'
const login = {
  state: {
	username:getCookie('USERNAME'),
	role:getCookie('ROLE'),
	introduce:'',
	newrouter:[],
	leftMenuShow: true
  },
  mutations: {
	SET_NAME:(state, name) => {
		state.username = name;
	},
	SET_ROLE:(state, role) => {
		state.role = role;
	},
	SET_INTRODUCE:(state, introduce) =>{
		state.introduce = introduce;
	},
	SET_NEWROUER:(state, newrouter) =>{
		state.newrouter = newrouter;
	},
	hideLeftMenu(state) {
		state.leftMenuShow = false;
	},
	showLeftMenu(state) {
		state.leftMenuShow = true;
	}
  },
  actions: {
	GetInfo({ commit}) {
		if(Boolean(sessionStorage.getItem('username')) != false) {
			commit('SET_NAME',sessionStorage.getItem('username'))
		}
		return cookie.get('token')
	}
  }
}
export default login;